import React, { Component } from 'react';
import { message } from 'antd';

import { querySaveSerialNumber } from '@api/core/serialNumber';

import { goBack } from '@comm/BackBtn';
import FormBase from './FormBase';

class PageAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentDidMount() {}

  /**
   * 提交报销
   */
  handSubmit = item => {
    item.unid = this.props.params.unid || this.state.dataInfo.unid;
    querySaveSerialNumber(item).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        goBack();
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    return (
      <div>
        <FormBase data={this.state.dataInfo} handSubmit={this.handSubmit} dataInfo={dataInfo} />
      </div>
    );
  }
}

export default PageAdd;



// WEBPACK FOOTER //
// ./src/components/boss/serialNumber/PageAdd.js